import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import "antd/lib/radio/style";
import _Radio from "antd/lib/radio";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/form/style";
import _Form from "antd/lib/form"; /*@通用页面-页面框架*/
import React from 'react';
var FormItem = _Form.Item;
var DysModal = /*#__PURE__*/function (_React$Component) {
  _inherits(DysModal, _React$Component);
  function DysModal(props) {
    var _this;
    _classCallCheck(this, DysModal);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DysModal).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidMount", function () {});
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (name, e) {
      if (name === 'is_active') {
        _this.setState(_defineProperty(_defineProperty({}, name, e && e.target ? e.target.value : e), "isEdit", true));
      } else if (name === 'isEdit') {
        _this.setState(_defineProperty({}, name, e));
      } else {
        _this.setState(_defineProperty({}, name, e && e.target ? e.target.value : ''));
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validateMail", function (rule, value, callback) {
      if (value) {
        var strRegex = /^1(3|4|5|6|7|8|9)\d{9}$/;
        var strRegex2 = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!(strRegex.test(value) || strRegex2.test(value))) {
          return callback("Incorrect format");
        }
      }
      return callback();
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "count", function () {
      var yztime = _this.state.yztime;
      var siv = setInterval(function () {
        _this.setState({
          yztime: yztime--
        }, function () {
          if (yztime <= -1) {
            clearInterval(siv); //倒计时( setInterval() 函数会每秒执行一次函数)，用 clearInterval() 来停止执行:
            _this.setState({
              loading: false,
              yztime: 59
            });
          }
        });
      }, 1000);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "send_code", function (e) {
      _this.props.form.validateFields(['verify_channel'], function (err) {
        if (!err) {
          _this.setState({
            loading: true
          });
          e.preventDefault();
          if (!_this.state.yztime == 0) {
            _this.count();
          }
          var verify_channel = _this.props.form.getFieldValue('verify_channel');
          _this.props.send_code({
            client_device: verify_channel,
            username: sessionStorage.getItem("userNm")
          });
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOk", function () {
      if (_this.state.isEdit) {
        _this.props.form.validateFields(function (err, values) {
          if (!err) {
            _this.props.onOk(values);
          }
        });
      } else {
        _this.props.cancel();
      }
    });
    _this.state = {
      loading: false,
      yztime: 59,
      isEdit: false,
      is_active: _this.props.initialValue && _this.props.initialValue.is_active ? _this.props.initialValue.is_active : '',
      verify_channel: _this.props.initialValue && _this.props.initialValue.verify_channel ? _this.props.initialValue.verify_channel : ''
    };
    return _this;
  }
  _createClass(DysModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var getFieldDecorator = this.props.form.getFieldDecorator;
      var modalFormLayout = {
        labelCol: {
          xs: {
            span: 5
          }
        },
        wrapperCol: {
          xs: {
            span: 16
          }
        }
      };
      var _this$props$initialVa = this.props.initialValue,
        initialValue = _this$props$initialVa === void 0 ? {} : _this$props$initialVa;
      return /*#__PURE__*/React.createElement(_Modal, {
        title: "Multifactor validation",
        visible: this.props.visible,
        onCancel: this.props.cancel,
        onOk: this.onOk,
        destroyOnClose: true
      }, /*#__PURE__*/React.createElement(_Form, null, /*#__PURE__*/React.createElement(FormItem, Object.assign({
        label: "Multifactor validation"
      }, modalFormLayout), getFieldDecorator('is_active', {
        initialValue: initialValue.is_active
      })(/*#__PURE__*/React.createElement(_Radio.Group, {
        onChange: function onChange(e) {
          return _this2.handleChange('is_active', e);
        }
      }, /*#__PURE__*/React.createElement(_Radio, {
        value: true
      }, "open"), /*#__PURE__*/React.createElement(_Radio, {
        value: false
      }, "close")))), this.state.is_active ? !this.state.isEdit ? /*#__PURE__*/React.createElement(FormItem, Object.assign({
        label: "Mobile/email"
      }, modalFormLayout), /*#__PURE__*/React.createElement("span", {
        style: {
          marginRight: '10px'
        }
      }, initialValue.verify_channel), /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          return _this2.handleChange('isEdit', true);
        },
        className: 'common-link-icon'
      }, "modify")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormItem, Object.assign({
        label: "Mobile/email"
      }, modalFormLayout), getFieldDecorator('verify_channel', {
        initialValue: initialValue.verify_channel || '',
        rules: [{
          validator: this.validateMail
        }, {
          required: true,
          message: "Please enter"
        }]
      })(/*#__PURE__*/React.createElement(_Input, {
        placeholder: "Please enter your email or phone number"
      }))), /*#__PURE__*/React.createElement(FormItem, Object.assign({
        label: "Verification Code"
      }, modalFormLayout), getFieldDecorator('code', {
        initialValue: '',
        rules: [{
          required: true,
          message: "Please enter"
        }]
      })(/*#__PURE__*/React.createElement(_Input, {
        placeholder: "Please enter",
        style: {
          width: '190px',
          marginRight: '20px'
        }
      })), /*#__PURE__*/React.createElement(_Button, {
        disabled: this.state.loading,
        htmlType: "submit",
        onClick: this.send_code
      }, this.state.loading ? this.state.yztime + '秒' : '获取验证码'))) : ''));
    }
  }]);
  return DysModal;
}(React.Component);
export default _Form.create()(DysModal);